<template>
    <div class="content">
        <div class="content--heading">
            <h1>Benutzer Profil</h1>
            <div class="heading--actions">

                <button @click="saveUser" class="btn btn--icon" :disabled="!passwordStrength || !compareValid">
                    <fa :icon="saving ? 'spinner' : 'save'" :class="{'fa-spin': saving}"></fa>
                </button>
            </div>
        </div>

        <div class="configurator--account panel">
            <label v-if="userId">
                <div class="description">Benutzer Aktiv</div>
                <div class="switch">
                    <input type="checkbox" v-model="user.active" value="1">
                    <div class="slider"></div>
                </div>
            </label>
            <label v-if="userId">Benutzer <input type="text" v-model="user.login" disabled></label>
            <label>Name <input type="text" v-model="user.username"></label>
            <label>Rolle <input type="text" v-model="user.role" disabled></label>
        </div>

        <div class="configurator--password panel">
            <label v-if="!userId">
                Altes Password
                <input type="password" v-model="oldPassword">
            </label>
            <label>
                Neues Password
                <input type="password" v-model="newPassword" :class="{error: passwordStrength !== true}">
                <div class="error-message">{{passwordStrength}}</div>
            </label>
            <label>
                Password wiederholen
                <input type="password" v-model="comparePassword" :class="{error: !compareValid}">

            </label>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'account',
        props: ['userData'],
        data() {
            return {
                user: {username: '', role: ''},
                userId: this.$route.params.userId,
                saving: false,
                oldPassword: null,
                newPassword: null,
                comparePassword: null
            }
        },
        async created() {
            let me = this;

            if (me.userId && me.userData.role === 'admin') {
                await me.$http.get('/data/users/' + me.userId).then(function (r) {
                    let response = r.data;

                    if (response.user) {
                        me.user = response.user;
                    }
                });
            } else {
                me.user = me.userData;
            }

        },
        methods: {
            getUser: function () {

            },
            saveUser: function () {
                let me = this;

                if ( me.compareValid && me.passwordStrength ) {
                    me.saving = true;

                    me.$http.put('/data/users/' + me.user.userId,
                        {
                            'active': me.user.active,
                            'old': me.oldPassword,
                            'new': me.newPassword,
                            'username': me.user.username,
                            'role': me.user.role
                        }
                    ).then(function (r) {
                        me.saving = false;
                        me.$notify({
                            text: r.data.msg,
                            type: r.data.msgType
                        });
                    });
                } else {
                    me.$notify({
                        text: 'Password form is not valid please check the errors',
                        type: 'error'
                    });
                }


            }
        },
        computed: {
            compareValid: function () {
                let me = this;

                if (me.newPassword && !me.comparePassword) {
                    return false;
                }
                if (me.newPassword && me.comparePassword && me.newPassword !== me.comparePassword) {
                    return false;
                }

                return true;
            },
            passwordStrength: function () {
                let me = this;

                if (!me.newPassword) {
                    return true;
                }

                if (me.newPassword.length < 8) {
                    return 'Das Password sollte mindestens 8 Zeichen lang sein';
                }

                if (!/\d/.test(me.newPassword)) {
                    return 'Das Password sollte mindestens eine Zahl enthalten'
                }

                if (!/[~`!#$%^&*+=\-[\]\\';,/{}|":<>?]/g.test(me.newPassword)) {
                    return 'Das Password sollte mindestens eine Sonderzeichen enthalten'
                }

                if (me.oldPassword === me.newPassword) {
                    return 'Das Neue Password unterscheidet sich nicht vom alten Password'
                }

                return true;
            }
        }
    }
</script>